/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'workorderAdd': {
    width: 250,
    height: 250,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M510.833 62.696c-247.644 0-448.406 200.762-448.406 448.407 0 247.655 200.762 448.416 448.406 448.416 247.656 0 448.417-200.761 448.417-448.416 0-247.645-200.761-448.407-448.417-448.407zm268.711 499.416H560.358v219.186H458.35V562.112H239.164V460.104H458.35V240.918h102.008v219.186h219.186v102.008z" _fill="#1afa29"/>'
  }
})
